<script setup>
import { ref, computed } from 'vue'
import { Tabs, Tab, Button, Icon, Card, Breadcrumb, Dropdown, Modal } from '@components'
import moment from 'moment'
import CustomSchedule from '../staff/CustomSchedule.vue'
import HoursEdit from './HoursEdit.vue'

// Settings store.
import { useSettings } from '@store/settings'
const $settings = useSettings()

import { useRouter, useRoute } from 'vue-router'
const route = useRoute()
const router = useRouter()

const saveBusinessHours = async () => {
    Log('working hours', $settings.businessHours)
    const saved = await $settings.saveSettings('business_hours', $settings.businessHours)
    Log('saved', saved)
    Toast.success('Updated working hours')
    prebook_admin.setup.hours_updated = true

    if (route.query.dashboard) {
        router.push({ name: 'dashboard' })
    }
}


const saveDaysOff = async () => {
    // $settings.daysOff.holidays = []
    await $settings.saveSettings('days_off', $settings.daysOff)
    Toast.success('Days off updated successfully')
}
// saveDaysOff()
const showCustomSchedule = ref(false)
const getHolidays = computed(() => {
    if (!$settings.daysOff.holidays) return []
    let h = []

    if ($settings.daysOff.holidays) {
        $settings.daysOff.holidays.forEach((holiday, index) => {

            let date = {
                title: holiday[0].title,
                from: {
                    fullDate: holiday[0].date,
                    day: moment(holiday[0].date, 'YYYY-MM-DD').format('dddd'),
                    date: moment(holiday[0].date, 'YYYY-MM-DD').format('DD'),
                    month: moment(holiday[0].date, 'YYYY-MM-DD').format('MMMM'),
                    year: moment(holiday[0].date, 'YYYY-MM-DD').format('YYYY'),
                },
                to: {},
                time: {
                    start: moment(holiday[0].from, 'HH:mm:ss').format('h:mm A'),
                    end: moment(holiday[0].to, 'HH:mm:ss').format('h:mm A'),
                }
            }

            if (holiday[1]) {

                date.to = {
                    fullDate: holiday[1].date,
                    day: moment(holiday[1].date, 'YYYY-MM-DD').format('dddd'),
                    date: moment(holiday[1].date, 'YYYY-MM-DD').format('DD'),
                    month: moment(holiday[1].date, 'YYYY-MM-DD').format('MMMM'),
                    year: moment(holiday[1].date, 'YYYY-MM-DD').format('YYYY'),
                }
            }

            console.log(date)
            h.push(date)
        })
    }
    return h
})

const holidays = ref(getHolidays.value)

const customScheduleForm = ref({
    title: '',
    from: {},
    to: {},
    time: {
        start: {},
        end: {}
    }
})

const generateSettingsHoliday = async (method = null) => {
    if (!$settings.daysOff.holidays) $settings.daysOff.holidays = []

    if (!customScheduleForm.value.from.fullDate && method !== 'delete') return

    if (router.currentRoute.value.query.index) {
        holidays.value[router.currentRoute.value.query.index] = {
            title: customScheduleForm.value.title,
            from: customScheduleForm.value.from,
            to: customScheduleForm.value.to,
            time: customScheduleForm.value.time
        }
    } else if (!router.currentRoute.value.query.index && method !== 'delete') {
        holidays.value.push({
            title: customScheduleForm.value.title,
            from: customScheduleForm.value.from,
            to: customScheduleForm.value.to,
            time: customScheduleForm.value.time
        })
    }

    $settings.daysOff.holidays = holidays.value.map(holiday => {
        let h = []
        console.log(holiday)
        if (holiday.from.fullDate) {
            h.push({
                title: holiday.title,
                date: holiday.from.fullDate,
                from: moment(holiday.time.start, 'h:mm A').format('HH:mm:ss'),
                to: moment(holiday.time.end, 'h:mm A').format('HH:mm:ss')
            })
        }

        if (holiday.to.fullDate && holiday.to.fullDate !== holiday.from.fullDate) {
            h.push({
                title: holiday.title,
                date: holiday.to.fullDate,
                from: moment(holiday.time.start, 'h:mm A').format('HH:mm:ss'),
                to: moment(holiday.time.end, 'h:mm A').format('HH:mm:ss')
            })
        }
        console.log(h)

        return h
    })
}

const addCustomSchedule = async () => {
    // generate holiday items depending on value
    await generateSettingsHoliday()

    // save that generated value in database
    await saveDaysOff()

    let { index, ...restParams } = router.currentRoute.value.query
    router.push({
        query: { ...restParams }
    })

    showCustomSchedule.value = false
    customScheduleForm.value = {
        title: '',
        from: {},
        to: {},
        time: {
            start: {},
            end: {}
        }
    }
}


const getCustomScheduleInfo = (holiday) => {
    let difference = moment(holiday.to.fullDate, 'YYYY-MM-DD').diff(moment(holiday.from.fullDate, 'YYYY-MM-DD'), 'days')
    let renderDate = () => {
        let from = moment(holiday.from.fullDate, 'YYYY-MM-DD').format('DD MMM')
        let to = moment(holiday.to.fullDate, 'YYYY-MM-DD').format('DD MMM')

        if (from == to) {
            return from
        } else if (from && to == 'Invalid date') {
            return from
        } else {
            return `${from} - ${to}`
        }
    }

    return {
        difference: difference + 1 || 1,
        renderDate: renderDate()

    }
}


const editCustomSchedule = async (holiday, index) => {
    showCustomSchedule.value = true
    router.push({
        query: {
            ...router.currentRoute.value.query,
            index: index
        }
    })
    customScheduleForm.value = holidays.value[index]
}

const deleteCustomSchedule = async (holiday, index) => {
    let confirm = await Prompt.fire({
        title: 'Delete holiday',
        message: 'Are you sure you want to delete this holiday?',
        ok: 'Yes, delete',
        cancel: 'No, cancel',
    })
    if (!confirm.ok) return

    if (index >= 0 && index < holidays.value.length) {
        holidays.value.splice(index, 1)
    } else {
        return Toast.error("Invalid index provided")
    }


    await generateSettingsHoliday('delete')
    await saveDaysOff()
}

const closeCustomeSchedule = () => {
    let { index, ...restParams } = router.currentRoute.value.query
    router.push({
        query: { ...restParams }
    })

    showCustomSchedule.value = false
}


const backButton = () => {
    if (route.query.dashboard) {
        router.push({ name: 'dashboard' })
    } else {
        router.push({ name: 'settings' })
    }
}
</script>


<template>
    <div class="md:max-w-[736px] m-auto mt-[-28px] transition" :class="{ 'opacity-60 pointer-events-none': $settings.isSaving }">
        <!-- breadcrumb -->
        <Breadcrumb wrapperClass="mb-[48px]" :items="[
            { icon: true, name: 'settings01', route: { name: 'settings' } },
            { name: 'Business Hours', route: { name: 'settings.business_hours' } }
        ]" />

        <!-- form tabs -->
        <Tabs default="working-hours" design="underline">
            <Tab id="working-hours">Working hours</Tab>
            <Tab id="days-off" v-if="$settings.addons.holidays_days_off">Days off</Tab>

            <!-- working hours -->
            <template #working-hours>
                <HoursEdit />

                <!-- For Edit Page -->
                <div class="flex items-center gap-10">

                    <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] mt-7 justify-between" @click.prevent="backButton">
                        <div class="w-[70%]">Back</div>
                        <template #before>
                            <Icon name="arrowNarrowLeft" size="20px"></Icon>
                        </template>

                    </Button>
                    <Button @click.prevent="saveBusinessHours" size="xl" type="primary" radius="square" classButton="w-full mt-7 justify-between">
                        <div class="w-[95%]">Update</div>
                    </Button>
                </div>

            </template>

            <!-- days off -->
            <template #days-off>
                <form @submit.prevent="saveDaysOff">
                    <Card cardClass="gap-5 mb-5 !p-4">
                        <template #header>
                            <div class="text-[#101828] text-lg font-semibold">Holidays & Days Off</div>
                        </template>
                        <template #default>
                            <div class="flex flex-col gap-5 md:flex-row md:flex-wrap">
                                <!-- {{ holidays }} -->
                                <div v-for="(holiday, index) in holidays" class="relative p-[6px_8px_8px_8px] border border-[#D0D5DD] rounded-lg w-full md:w-[156px] text-center">
                                    <Dropdown contentClass="top-[30px] w-[117px]">
                                        <Icon name="dotsVertical" size="36px" class="text-[#98A2B3] p-2 absolute top-0 left-[-5px] cursor-pointer"></Icon>

                                        <template #content>
                                            <div class="flex flex-col gap-1">
                                                <div class=" rounded-md mx-1.5 my-0.5 transition">
                                                    <div @click="editCustomSchedule(holiday, index)" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                                        <Icon size="16px" name="edit05" />
                                                        <div class="text-[#344054] text-sm font-medium">Edit</div>
                                                    </div>
                                                    <div @click="deleteCustomSchedule(holiday, index)" class="px-2.5 py-[9px] flex gap-2 items-center hover:bg-[#F9FAFB] rounded-md cursor-pointer transition-all duration-300">
                                                        <Icon size="16px" name="trash01" />
                                                        <div class="text-[#344054] text-sm font-medium">Delete</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                    </Dropdown>
                                    <div class="text-[#7F56D9] text-4xl font-semibold leading-normal mt-[12px]">{{ getCustomScheduleInfo(holiday).difference }}</div>
                                    <div class="text-[#667085] text-sm font-normal ">{{ getCustomScheduleInfo(holiday).difference > 1 ? 'Days' : 'Day' }}</div>
                                    <div class="text-[#667085] text-sm font-normal min-h-5">{{ holiday.title }}</div>
                                    <div class="text-[#667085] text-xs font-medium py-2 px-3 mt-6 bg-[#F2F4F7] rounded">{{ getCustomScheduleInfo(holiday).renderDate }}</div>
                                </div>
                                <div @click="showCustomSchedule = true" class="min-h-[160px] cursor-pointer p-[6px_8px_8px_8px] border border-dashed border-[#D0D5DD] rounded-lg w-full md:w-[156px] flex flex-col items-center justify-center">
                                    <Icon name="plus" size="40px" class="p-1.5 text-[#98A2B3] rounded-full border-2 border-dashed border-[#D0D5DD]"></Icon>
                                    <div class="text-[#667085] text-sm font-normal mt-4">Add day</div>
                                </div>
                            </div>
                        </template>
                    </Card>

                    <div class="flex items-center gap-10">

                        <Button size="xl" type="secondary_gray" radius="square" classButton="!w-[180px] mt-7 justify-between" @click.prevent="backButton">
                            <div class="w-[70%]">Back</div>
                            <template #before>
                                <Icon name="arrowNarrowLeft" size="20px"></Icon>
                            </template>

                        </Button>
                        <Button submit size="xl" type="primary" radius="square" classButton="w-full mt-7 justify-between">
                            <div class="w-[95%]">Update</div>
                        </Button>
                    </div>
                </form>
            </template>

        </Tabs>

        <Modal class="z-[100]" v-if="showCustomSchedule">
            <!-- header  -->
            <template #header>
                <div @click="closeCustomeSchedule()" class="cursor-pointer px-8 py-6 border-b-[#EAECF0] border-b flex items-center justify-between">
                    <div class="flex items-center gap-5 text-[#101828] text-lg font-semibold">
                        <Icon name="arrowNarrowLeft" size="24px"></Icon> Back
                    </div>
                </div>
            </template>
            <!-- Custom schedule -->
            <template #default>
                <CustomSchedule title="Holidays & Days Off" v-model="customScheduleForm" />

                <div class="md:w-[446px] m-auto flex flex-col md:flex-row items-center gap-2 md:gap-10">
                    <Button @click.prevent="closeCustomeSchedule()" size="xl" type="secondary_gray" radius="square" classButton="w-full md:!w-[180px] md:mt-10 justify-between">
                        <div class="w-[70%]">Cancel</div>
                        <template #before>
                            <Icon name="arrowNarrowLeft" size="20px"></Icon>
                        </template>
                    </Button>
                    <Button @click.prevent="addCustomSchedule()" :disabled="!customScheduleForm.from.fullDate" submit size="xl" type="primary" radius="square" classButton="w-full md:mt-10 justify-between">
                        <div class="w-[95%]">Save Schedule</div>
                    </Button>
                </div>
            </template>
        </Modal>
    </div>
</template>
